import { HttpClient } from '../http-client';
import { Timestamp } from '../models';
import { Widget } from './widget';

const RESOURCE_URL = '/dashboards';

export interface Dashboard {
  dashboardId: number;
  isDefault: boolean;
  dashboardName: string;
  createdAt: Timestamp;
  updatedAt: Timestamp;
  widgets: Widget[];
  shared: boolean;
  createdBy: number;
}

export type DashboardPayload = Pick<Dashboard, 'dashboardName' | 'shared'>;
export type DuplicateDashboardPayload = Pick<
  Dashboard,
  'dashboardName' | 'shared' | 'dashboardId'
>;

const getUrl = (id: number) => `${RESOURCE_URL}/${id}`;

class DashboardHttpClient extends HttpClient {
  public init = (): Promise<{ dashboard: Dashboard[] }> => {
    return this.post(`${RESOURCE_URL}/init`);
  };

  public createDashboard = (payload: DashboardPayload): Promise<Dashboard> => {
    return this.post(RESOURCE_URL, payload);
  };

  public updateDashboard = (
    dashboardId: number,
    payload: DashboardPayload,
  ): Promise<Dashboard> => {
    return this.put(getUrl(dashboardId), payload);
  };

  public duplicateDashboard = (
    payload: DashboardPayload,
  ): Promise<Dashboard> => {
    return this.post(`${RESOURCE_URL}/clone`, payload);
  };

  public deleteDashboard = (dashboardId: number): Promise<Dashboard> => {
    return this.delete(getUrl(dashboardId));
  };

  public getAllDashboards = async (): Promise<Dashboard[]> => {
    const result = await this.get<{ dashboard: Dashboard[] }>(RESOURCE_URL);

    // TODO:: Check with backend to remove dashboard key and send the response directly as array.
    return result.dashboard;
  };

  public getDashboard = (dashboardId: number): Promise<Dashboard> => {
    return this.get(`${RESOURCE_URL}/${dashboardId}`);
  };
}

export const DashboardAPI = new DashboardHttpClient();
